<style lang="less"></style>
<i18n>
{
  "zh": {
    "saveSymbolToLocal": "保存符号",
    "newLib": "新建符号库",
    "openLib": "导入符号库",
    "addImgLibrary": "导入图片生成库",
    "addTextCPoint": "添加带有控制点的文本框",
    "addText": "在形状上添加文本框",
    "addCPoint": "自动添加连接点",
    "removeCPoint": "删除连接点",
    "saveTemplateThumbnail": "保存模板缩略图",
    "saveThumbSvg": "保存模板缩略SVG",
    "themeEffect": " 生成主题效果",
    "tint": "亮度",
    "cancelSubHide": "取消子对象隐藏",
    "subInsertToRef": "多选非主形状插入主形状"
  },
  "en": {
    "saveSymbolToLocal": "Save Symbol",
    "newLib": "New Library",
    "openLib": "Import Library",
    "addImgLibrary": "New Library From Pictures",
    "addTextCPoint": "Add Text With Control Point",
    "addText": "Add Text Above Shape",
    "addCPoint": "Add Connection Points Automatically",
    "removeCPoint": "Remove Connection Points",
    "saveTemplateThumbnail": "Save Template Thumbnail",
    "saveThumbSvg": "Save Template ThumbSVG",
    "themeEffect": "Generate Theme Effect",
    "tint": "Tint",
    "cancelSubHide": "cancel mask for subobject",
    "subInsertToRef": "多选非主形状插入主形状"
  },
  "fr": {
    "saveSymbolToLocal": "Enregistrer le symbole dans la section locale",
    "newLib": "Nouvelle bibliothèque",
    "openLib": "Importer la bibliothèque de symboles",
    "addImgLibrary": "Importer une bibliothèque de génération d'images",
    "addTextCPoint": "Ajouter une zone de texte avec des points de contrôle",
    "addText": "Ajouter une zone de texte au-dessus de la forme",
    "addCPoint": "Ajouter automatiquement des points de connexion",
    "removeCPoint": "Supprimer le point de connexion",
    "saveTemplateThumbnail": "Enregistrer la miniature du modèle",
    "saveThumbSvg": "Enregistrer la miniature du modèle SVG",
    "themeEffect": "Générer des effets de thème",
    "tint": "Luminosité",
    "cancelSubHide": "Annuler le masque du sous-objet",
    "subInsertToRef": "Sélection multiple de formes non primaires insérent une forme principale"
  },
  "de": {
    "saveSymbolToLocal": "Symbol speichern",
    "newLib": "Neue Bibliothek",
    "openLib": "Symbole importieren",
    "addImgLibrary": "Neue Bilder-Bibliothek",
    "addTextCPoint": "Text mit Kontrollpunkt hinzufügen",
    "addText": "Text über Form hinzufügen",
    "addCPoint": "Verbindungspunkte automatisch hinzufügen",
    "removeCPoint": "Verbindungspunkte entfernen",
    "saveTemplateThumbnail": "Minibild der Vorlage speichern",
    "saveThumbSvg": "Vorlage speichern ThumbSVG",
    "themeEffect": "Themeneffekt erzeugen",
    "tint": "Farbton",
    "cancelSubHide": "Verbergung des Unterobejekts abbrechen",
    "subInsertToRef": "Mehrfachauswahl der Nicht-Hauptform zum Einfügen in die Hauptform"
  },
  "jp": {
    "saveSymbolToLocal": "図形をローカルに保存",
    "newLib": "ライブラリを新規作成",
    "openLib": "記号ライブラリをインポート",
    "addImgLibrary": "画像生成ライブラリをインポート",
    "addTextCPoint": "コントロールポイント付きのテキストボックスを追加",
    "addText": "図形の上にテキストボックスを追加",
    "addCPoint": "コントロールポイントを自動生成",
    "removeCPoint": "コントロールポイントを削除",
    "saveTemplateThumbnail": "テンプレートのサムネイルを保存",
    "saveThumbSvg": "テンプレートのサムネイルSVGを保存",
    "themeEffect": "テーマの効果を作成",
    "tint": "明るさ",
    "cancelSubHide": "子オブジェクトを再表示",
    "subInsertToRef": "主形状を挿入"
  },
  "es": {
    "saveSymbolToLocal": "Guardar el símbolo",
    "newLib": "Nueva Biblioteca",
    "openLib": "Importar biblioteca",
    "addImgLibrary": "Nueva biblioteca de fotos",
    "addTextCPoint": "Añadir texto con punto de control",
    "addText": "Agregar texto sobre la forma",
    "addCPoint": "Añadir puntos de conexión automáticamente",
    "removeCPoint": "Eliminar los puntos de conexión",
    "saveTemplateThumbnail": "Guardar la plantilla de la miniatura",
    "saveThumbSvg": "Guardar plantilla PulgarSVG",
    "themeEffect": "Generar el efecto del tema",
    "tint": "Tinte",
    "cancelSubHide": "Cancelar la máscara para el subobjeto",
    "subInsertToRef": "Seleciona Forma principal para insertar otras forma"
  },
  "pt": {
    "saveSymbolToLocal": "Gravar Símbolo",
    "newLib": "Nova Biblioteca",
    "openLib": "Importar para Biblioteca",
    "addImgLibrary": "Nova Biblioteca a Partir de Imagens",
    "addTextCPoint": "Adicionar Texto com Ponto de Controle",
    "addText": "Adicionar Texto Sobre a Forma",
    "addCPoint": "Adicionar Pontos de Conexão Automaticamente",
    "removeCPoint": "Remover Pontos de Conexão",
    "saveTemplateThumbnail": "Gravar Modelo de Miniatura",
    "saveThumbSvg": "Gravar Modelo ThumbSVG",
    "themeEffect": "Gerar Efeito de Tema",
    "tint": "Tinta",
    "cancelSubHide": "cancelar máscara para subobjeto",
    "subInsertToRef": "Seleção Múltipla de Forma não Principal para Inserir na Forma Principal"
  },
  "it": {
    "saveSymbolToLocal": "Salva Simbolo",
    "newLib": "Nuova Libreria",
    "openLib": "Importa Simboli",
    "addImgLibrary": "Nuova Libreria da Immagini",
    "addTextCPoint": "Aggiungi Testo con Punto di Controllo",
    "addText": "Aggiungi Testo Sulla Forma",
    "addCPoint": "Aggiungi Punti di Connessione Automaticamente",
    "removeCPoint": "Rimuovi Punti di Connessione",
    "saveTemplateThumbnail": "Salva Miniatura Modello",
    "saveThumbSvg": "Salva Miniatura Modello SVG",
    "themeEffect": "Genera Effetto Tema",
    "tint": "Colore",
    "cancelSubHide": "Cancella maschera del sotto-oggetto",
    "subInsertToRef": "Seleziona più forme secondarie nella forma principale"
  },
  "tw": {
    "saveSymbolToLocal": "儲存符號",
    "newLib": "新建庫",
    "openLib": "導入符號庫",
    "addImgLibrary": "導入圖片生成庫",
    "addTextCPoint": "添加帶有控制點的文本框",
    "addText": "在形狀上方添加文本框",
    "addCPoint": "自動添加連接點",
    "removeCPoint": "生成連接點",
    "saveTemplateThumbnail": "儲存模板縮略圖",
    "saveThumbSvg": "儲存模板縮略SVG",
    "themeEffect": "生成主題效果",
    "tint": "亮度",
    "cancelSubHide": "取消子對象隱藏",
    "subInsertToRef": "多選非主形狀插入主形狀"
  }
}
</i18n>
<template>
    <MenuList :menuList="menuList" @handleClicks="handleClicks(...arguments)" :showTippy="false">
        <template #addImgToLib>
            <input ref="importImgToLibrary" type="file" accept=".png,.jpg,.jpeg,.bmp" multiple style="display: none" @change="addImgToLib($event)" />
        </template>
    </MenuList>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import appConfig from "@/public/globalConfig";
    import { EDRAWMAX_USE_CUSTOMLIBRARY } from "@/env/";
    import MenuList from "@/app/components/MenuList.vue";

    @Component({
        components: {
            MenuList,
        },
    })
    export default class SymbolDrop extends Vue {
        isBuild = appConfig.isBuild;
        worker: any;
        userWorkerURL: string = appConfig.userWorkerURL;

        get menuList() {
            let list = [
                {
                    key: "saveSymbolToLocal",
                    isRender: !this.isBuild,
                    disabled: !this.isActiveShape,
                    extraClass: this.activeFunc == "shapeSaveSymbol" && "activeFunc",
                },
                {
                    key: "newLib",
                    isRender: this.useCustomLib,
                    extraClass: this.activeFunc == "shapeNewLibrary" && "activeFunc",
                },
                {
                    key: "openLib",
                    isRender: this.useCustomLib,
                    extraClass: this.activeFunc == "shapeOpenLibrary" && "activeFunc",
                },
                {
                    key: "addImgLibrary",
                    isRender: false,
                    extraClass: this.activeFunc == "shapeNewLibraryFromPictures" && "activeFunc",
                },
                { divide: true, isRender: !this.isBuild },
                {
                    key: "addTextCPoint",
                    disabled: !this.isActiveShape || this.isMultisel || this.isGrouped,
                    extraClass: this.activeFunc == "shapeAddTextWidthControlPoint" && "activeFunc",
                },
                {
                    key: "addText",
                    disabled: !this.isActiveShape || this.isMultisel || this.isGrouped,
                    extraClass: this.activeFunc == "shapeAddTextAboveShape" && "activeFunc",
                },
                { divide: true },
                {
                    key: "addCPoint",
                    disabled: !this.isActiveShape || this.isMultisel,
                    extraClass: this.activeFunc == "shapeAddConnectionPointsAutomatically" && "activeFunc",
                },
                {
                    key: "removeCPoint",
                    disabled: !this.isActiveShape || this.isMultisel,
                    extraClass: this.activeFunc == "shapeRmoveConnectionPoints" && "activeFunc",
                },
                { key: "saveTemplateThumbnail", isRender: !this.isBuild },
                { key: "saveThumbSvg", isRender: !this.isBuild },
                { key: "themeEffect", isRender: !this.isBuild },
                {
                    key: "tint",
                    isRender: !this.isBuild,
                    disabled: !this.isActiveShape,
                    checked: this.isDepTint,
                },
                { key: "cancelSubHide", isRender: !this.isBuild, disabled: !this.isActiveGroup },
                {
                    key: "subInsertToRef",
                    isRender: !this.isBuild && !this.isTeamsApp,
                    disabled: !this.isActiveGroup,
                },
                { slot: "addImgToLib" },
            ];

            let resultList = [];
            list.filter((i) => (i.hasOwnProperty("isRender") ? i.isRender : true)).map((item) => {
                resultList.push(item.divide ? item : Object.assign({}, item, { label: this.$t(item.key) }));
            });
            return { container: "symbol-drops", list: resultList };
        }
        handleClicks(...args) {
            let key = args[0],
                event = args[1];
            let clickEvents = new Map([
                [
                    "saveSymbolToLocal",
                    () => {
                        event.stopPropagation();
                        this.isActiveShape && this.saveSymbol();
                    },
                ],
                [
                    "newLib",
                    () => {
                        event.stopPropagation();
                        this.showAddLibrary();
                    },
                ],
                [
                    "openLib",
                    () => {
                        event.stopPropagation();
                        this.showOpenLibrary();
                    },
                ],
                [
                    "addImgLibrary",
                    () => {
                        event.stopPropagation();
                        this.addImgs();
                    },
                ],
                [
                    "addTextCPoint",
                    () => {
                        event.stopPropagation();
                        this.isActiveShape && this.symbolOperates(1);
                    },
                ],
                [
                    "addText",
                    () => {
                        event.stopPropagation();
                        this.isActiveShape && this.symbolOperates(2);
                    },
                ],
                [
                    "addCPoint",
                    () => {
                        event.stopPropagation();
                        this.isActiveShape && this.symbolOperates(3);
                    },
                ],
                [
                    "removeCPoint",
                    () => {
                        event.stopPropagation();
                        this.isActiveShape && this.symbolOperates(4);
                    },
                ],
                [
                    "saveTemplateThumbnail",
                    () => {
                        event.stopPropagation();
                        this.saveTemplateThumbnail2();
                    },
                ],
                [
                    "saveThumbSvg",
                    () => {
                        event.stopPropagation();
                        this.saveToSvg2();
                    },
                ],
                [
                    "themeEffect",
                    () => {
                        event.stopPropagation();
                        this.themeEffect();
                    },
                ],
                [
                    "tint",
                    () => {
                        event.stopPropagation();
                        this.isActiveShape && this.switchTint();
                    },
                ],
                [
                    "cancelSubHide",
                    () => {
                        event.stopPropagation();
                        this.cancelSubHid();
                    },
                ],
                [
                    "subInsertToRef",
                    () => {
                        event.stopPropagation();
                        this.subInsToRef();
                    },
                ],
            ]);
            const onClicks = clickEvents.get(key);
            onClicks && onClicks();
        }
        closeMenu() {
            // 关闭下拉菜单
            this.$emit("closeDrop");
        }
        showDialog(target) {
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: target,
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
        }
        saveSymbol() {
            // 保存符号
            window["_view"].saveAsSymbol();
            this.$track("menu", "symbol", "saveAsSymbol");
            this.closeMenu();
        }
        get showUpgradeVal() {
            return this.$store.state.publicStore.showUpgrade;
        }
        checkCloudSpaceLimit() {
            if (this.isFullCouldSpace) {
                if (!this.vip && this.showUpgradeVal != "cloudSpace") {
                    this.$checkAuth({ type: "cloudSpace", buyTrigger: "cloudSpacePop" });
                } else if (this.showUpgradeVal != "cloudSpaceVIP") {
                    if (this.fuser) {
                        this.$bus.$emit("showCloudSpaceVipTips");
                    } else {
                        this.$checkAuth({ type: "cloudSpaceVIP", buyTrigger: "cloudSpacePop" });
                    }
                }
                return true;
            }
            return false;
        }
        showAddLibrary() {
            this.closeMenu();
            let ts: any = this;
            if (ts.checkCloudSpaceLimit()) return;
            this.$track("menu", "symbol", "NewLibrary");
            this.showDialog("AddLibrary");
        }
        showOpenLibrary() {
            this.closeMenu();
            this.$track("menu", "symbol", "OpenLibrary");
            this.showDialog("OpenLibrary");
        }
        addImgs() {
            this.closeMenu();
            let ts: any = this;
            if (!ts.$checkAuth({ type: "addImgToLib" })) return;
            this.$track("menu", "symbol", "addImgToLib");
            (this.$refs.importImgToLibrary as HTMLInputElement).click();
        }
        addImgToLib(event) {
            let DBName = this.$store.state.library.extraDB[0];
            let tableName = `${this.lang == "zh" ? "图片" : "image"}`;

            this.$store.commit("setStatus", {
                type: "loadingTextType",
                data: "library",
            });
            this.$store.commit("setStatus", {
                type: "Loading",
                data: true,
            });
            let userInfo = this.$store.state.user.userInfo;
            window["_view"].addImgToLibrary(event.target.files).then((insertData) => {
                this.worker = new Worker(this.userWorkerURL);
                this.worker.postMessage({
                    type: "createByImg",
                    urls: this.urls,
                    data: {
                        DBName,
                        tableName,
                        insertData: insertData,
                        versionDB: `userDBVersion_${userInfo.user_id}`,
                        userInfo: {
                            id: userInfo.user_id,
                            token: userInfo.token,
                        },
                        libType: 0,
                    },
                });
                this.worker.onmessage = (e) => {
                    let message = e.data;
                    console.log("img", message);
                    if (message.type === "newOK") {
                        this.worker.terminate();
                        this.$store.commit("setStatus", {
                            type: "Loading",
                            data: false,
                        });
                        event.target.value = "";
                        let ts: any = this;
                        uploadStoreInfo(message.children);
                        ts.$bus.$asyncEmit("uploadToCloud", { message });
                        // window['_view'].saveLib(DBName, message.children[0].tableName).then((files) => {
                        // 	let fileSize = files[0].file.size + files[1].file.size;
                        // 	this.$store.dispatch('upLoadLibrary', {
                        // 		param: {
                        // 			id: userInfo.user_id,
                        // 			token: userInfo.token,
                        // 			targetUrl: 'customlib'
                        // 		},
                        // 		size: fileSize,
                        // 		files: files,
                        // 		tableName: message.children[0].tableName,
                        // 		version: message.data.version,
                        // 		tableID: message.data.tableID,
                        // 	}).then(e => {
                        // 		this.$edApi.getCustomLibraryList({id: userInfo.user_id,token: userInfo.token,type: 0}).then(e => {
                        // 			this.$store.commit('setLibraryState', {
                        // 				type: 'ossList',
                        // 				data: e.data
                        // 			})
                        // 			uploadStoreInfo(message.children);
                        // 		})
                        // 		console.log('new library upload ok')
                        // 	})
                        // })
                    } else if (message.type === "addProcess") {
                        setProcess(message.data);
                    }
                };
            });
            let setProcess = (num) => {
                this.$store.commit("setStatus", {
                    type: "LoadingProcess",
                    data: num > 1 ? 1 : num < 0 ? 0 : num,
                });
            };
            let uploadStoreInfo = (tableArr) => {
                // create table
                let menu = this.$store.state.library.menuList;
                let showList = this.$store.state.library.displayList;
                let checkbox = JSON.parse(JSON.stringify(this.$store.state.library.checkbox));

                checkbox[DBName].push(tableArr[0].id); // 更新选中数据
                this.$store.state.library.checkbox = checkbox;

                for (let i = 0; i < menu.length; i++) {
                    // 更新用户自定义库的表名
                    if (menu[i].groupName == DBName) {
                        menu[i].children = menu[i].children.concat(tableArr);
                    }
                }
                for (let i = 0; i < showList.length; i++) {
                    if (showList[i].groupName == DBName) {
                        showList[i].children.push({
                            tableName: tableName,
                            showList: [],
                        });
                    }
                }

                this.$store.commit("setStatus", {
                    type: "selectLibrary",
                    data: [DBName, tableName, tableArr[0].id],
                });
            };
        }
        symbolOperates(index: number) {
            let view = window["_view"];
            view && view.symbolOperate(index);
            this.closeMenu();
        }
        themeEffect() {
            // 生成主题效果
            window["_view"].saveThemeEffect();
        }
        saveToSvg2() {
            this.closeMenu();
            window["_view"]._doc.saveToSvg(undefined, true);
        }
        /** 保存模板缩略图 */
        saveTemplateThumbnail2() {
            window["_view"].saveTemplateThumbnail();
            this.closeMenu();
        }
        // 切换Tint依赖
        switchTint() {
            window["_view"].setDependTint(!this.isDepTint);
            this.closeMenu();
        }
        // 取消子对象隐藏
        cancelSubHid() {
            window["_view"].cancelSubHide();
            this.closeMenu();
        }
        subInsToRef() {
            window["_view"].subInsertToRef();
            this.closeMenu();
        }
        get isActiveShape() {
            return this.$store.state.shape.isActived;
        }
        get isGrouped() {
            return this.$store.state.shape.isGrouped;
        }
        get isMultisel() {
            return this.$store.state.shape.isMultiSel;
        }
        get isDepTint() {
            return this.$store.state.shape.depTint;
        }
        get isActiveGroup() {
            return this.$store.state.shape.unGroup;
        }
        get isActiveMulti() {
            return this.$store.state.shape.isActived && this.$store.state.shape.isMultiSel;
        }
        get activeFunc() {
            return this.$store.state.ui.activeFunc;
        }
        get useCustomLib() {
            return EDRAWMAX_USE_CUSTOMLIBRARY && window.EDCONFIG.MY_LIBRARY_ENABLE;
        }
        mounted() {}

        created() {}
    }
</script>
